import { DateTime } from 'luxon'

import { formatMoney } from 'accounting'

import { Box, ListItem, Text } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import { generateUrls } from '@hooks/useInvoice'

import type { CampaignModel, InvoiceModel } from '@models/types'

type InvoiceListItemProps = {
  campaign: CampaignModel,
  invoice: InvoiceModel,
}

const PendingInvoiceListItem = (props: InvoiceListItemProps) => {
  const { campaign, invoice } = props

  const { dates, id, total } = invoice

  const date = digObject(dates, 'due.date', '')

  const dateNow = DateTime.now()
  const formattedDueDate = DateTime.fromFormat(date, 'dd/MM/yyyy')
  const pastDueDate = dateNow >= formattedDueDate

  const { editInvoiceUrl } = generateUrls(invoice, { prefixRoute: `campaigns/${campaign.id}/edit/accounting` })

  return (
    <ListItem
      boxProps={{
        alignItems: 'center',
        as: 'a',
        borderBottom: '1px dashed',
        padding: 'large',
      }}
      href={editInvoiceUrl}
      showAngleIcon
    >
      <Box flexDirection="column">
        <Text fontSize="small">Invoice #{id}</Text>

        <Text
          color={pastDueDate ? 'red' : 'bodyFontLightColor'}
          fontSize="xsmall"
          marginTop="small"
        >
          Due: {date}
        </Text>
      </Box>

      <Box alignItems="flex-end" flexDirection="column" marginLeft="auto">
        <Text fontSize="small">{formatMoney(total)}</Text>
      </Box>
    </ListItem>
  )
}

export default PendingInvoiceListItem
